(function() { module.exports = window["lodash"]; }());